import React from 'react';
import { CheckCircle2, MapPin, ShieldCheck, ThumbsUp } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <CheckCircle2 className="w-5 h-5 text-teal" data-id="element-204" />,
    text: 'Free Estimates'
  }, {
    icon: <MapPin className="w-5 h-5 text-teal" data-id="element-205" />,
    text: 'Las Vegas / Henderson'
  }, {
    icon: <ShieldCheck className="w-5 h-5 text-teal" data-id="element-206" />,
    text: 'Locally Owned'
  }, {
    icon: <ThumbsUp className="w-5 h-5 text-teal" data-id="element-207" />,
    text: 'Quality Stone & Turf'
  }];
  return <div className="bg-charcoal-soft py-4 border-b border-charcoal" data-id="element-208">
      <div className="container mx-auto px-4" data-id="element-209">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-210">
          {items.map((item, index) => <div key={index} className="flex items-center gap-3 justify-center md:justify-start" data-id="element-211">
              <div className="flex-shrink-0" data-id="element-212">{item.icon}</div>
              <span className="text-sand text-sm font-medium leading-tight" data-id="element-213">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}